import axios from "axios";
import swal from "sweetalert";
import { buildApiUrl, encodePathValue, headersRequest } from "../helpers";

export const deleteProjectById = (uid, success, text) => {
  const requestUrl = buildApiUrl(`projects/${encodePathValue(uid)}`);

  return axios
    .delete(requestUrl, headersRequest(requestUrl))
    .then(() => {
      swal(text.text1, text.text2, "success").then(() => {
        if (success) success();
      });
    })
    .catch(() => {
      swal("¡Ups!", text.text3, "error");
    });
};